module.exports = __webpack_public_path__ + "static/img/third2_2_2_active.8649d71e.jpg";